import { useQuery } from '@apollo/client'
import { Select, SelectProps } from 'antd'
import React, { useMemo } from 'react'
import { TYPE_EQUIPEMENT_EQUIPEMENT } from '../../apollo/query/typeequipement.query'
import { D4_Typeequipement } from '../../types'

const D4SelectEquipement: React.FC<SelectProps<any> & { coproprieteId: number }> = ({ coproprieteId, ...rest }) => {
  const { data: typeEquipement } = useQuery<{ typeEquipement: D4_Typeequipement[] }>(TYPE_EQUIPEMENT_EQUIPEMENT, {
    skip: !coproprieteId,
    variables: {
      coproprieteid: coproprieteId,
    },
  })

  const equipementOptions = useMemo(
    () =>
      typeEquipement?.typeEquipement.map((eq) => ({
        label: eq.typeequipement,
        value: eq.id,
      })) ?? [],
    [typeEquipement?.typeEquipement]
  )

  return (
    <Select
      options={equipementOptions}
      showArrow
      showSearch
      optionFilterProp="label"
      style={{ width: '100%' }}
      placeholder="Selectionnez un équipement"
      {...rest}
    />
  )
}

export default D4SelectEquipement
